module.exports = __webpack_public_path__ + "img/LT112040733.b7dab79b.png";